module.exports = __webpack_public_path__ + "assets/img/404.78bb75e5.png";